import { AuthService } from './auth.service';
import { InjectionToken } from '@angular/core';

export const AUTH_SERVICE = new InjectionToken<AuthService>(
  'AuthServiceProvider'
);
